import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as bp from 'view/styles/breakpoints';
import { FOOTER_HEIGHT } from '../layout/footer/styled';
import { portalCardsContainerStyle } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';

const HEADER_HEIGHT = `${grid.multiple(10).px}`;
const WRAPPER_MIN_HEIGHT = `calc(100vh - ${FOOTER_HEIGHT}px - ${HEADER_HEIGHT})`;
export const Wrapper = styled.div`
    min-height: ${WRAPPER_MIN_HEIGHT};
    padding: ${grid.multiple(15).px} ${token('space.500', '40px')} 0 ${token('space.500', '40px')};

    ${bp.fromMobile.css`
    padding-top: ${token('space.1000', '80px')};
`}
`;

export const ExperienceContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
    margin-top: ${token('space.300', '24px')};

    ${portalCardsContainerStyle}
`;

export const CardsContainer = styled.ul`
    margin: 0 -${grid.multiple(5).px} ${token('space.200', '16px')};
    display: flex;
    flex-wrap: wrap;
    border: 1px transparent;
    position: relative;
    justify-content: center;
    list-style: none;
    padding: 0;
`;
